import React, { createContext, useContext, useMemo, useState } from 'react';

const AdminModeContext = createContext(null);

export const useAdminMode = () => {
  const ctx = useContext(AdminModeContext);
  if (!ctx) {
    throw new Error('useAdminMode must be used within AdminModeProvider');
  }
  return ctx;
};

export const AdminModeProvider = ({ children }) => {
  const [enabled, setEnabled] = useState(() => {
    try {
      return sessionStorage.getItem('ditrisAdminMode') === 'true';
    } catch {
      return false;
    }
  });

  const setAdminModeEnabled = (value) => {
    setEnabled(value);
    try {
      sessionStorage.setItem('ditrisAdminMode', value ? 'true' : 'false');
    } catch {
      // ignore
    }
  };

  const value = useMemo(
    () => ({
      adminModeEnabled: enabled,
      enableAdminMode: () => setAdminModeEnabled(true),
      disableAdminMode: () => setAdminModeEnabled(false),
      setAdminModeEnabled,
    }),
    [enabled]
  );

  return <AdminModeContext.Provider value={value}>{children}</AdminModeContext.Provider>;
};
